// extracted by mini-css-extract-plugin
module.exports = {"mainBlock__allLetters":"lettersList_mainBlock__allLetters__ht2B9","allLetterDown":"lettersList_allLetterDown__1HAJq","down":"lettersList_down__1AVw4"};